import { render } from "./PermissionCheckbox.vue?vue&type=template&id=146910c2"
import script from "./PermissionCheckbox.vue?vue&type=script&lang=js"
export * from "./PermissionCheckbox.vue?vue&type=script&lang=js"
script.render = render

export default script